export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 60,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_warehouse') || '客户仓库',
    field: 'whName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
  },
  {
    title: that.$l('table_label_RegionName_wh') || '所在地区',
    field: 'whRegionName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
  },
  {
    title: that.$l('table_label_transitTimes') || '运输周期',
    field: 'transitTimes',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
  },
  {
    title: that.$l('table_label_planContainerQty') || '货柜数量',
    field: 'planContainerQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_planUnitQty') || '产品数量',
    field: 'planUnitQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_planSpecQty') || '规格数量',
    field: 'planSpecQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 160,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },

]
